import {FBFieldBase} from "../../Fields/Core/FBFieldBase";
import {ShowHideConditionOptions, ValidationConditionOptions} from "../../Fields/Core/ConditionOptions";
import {ConditionProcessorBase} from "./ConditionProcessorBase";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {ContainerDataRetriever} from "FormBuilder/Core/FormBuilder.Model";

export class ValidationConditionProcessor  extends ConditionProcessorBase{
    public Options:ValidationConditionOptions;
    public Field:FBFieldBaseModel;


    public Initialize(formBuilder: ContainerDataRetriever, condition: ValidationConditionOptions): this {
        throw Error("Invalid initialization, please use initialize with fields instead");
    }


    GetExecuteOnFieldChange(): boolean {
        return false;
    }

    GetExecuteOnInitialize(): boolean {
        return false;
    }

    InitializeWidthFields(field: FBFieldBaseModel, condition: ValidationConditionOptions): this {
        this.Field=field;
        return super.Initialize(field.FormBuilder, condition);
    }

    ExecuteFalseAction(immediate:boolean) {
        if(this.Options.IsInvalidWhenTrue)
            this.Field.RemoveError("Validation_"+this.Options.Id);
        else
            this.Field.AddError( "Validation_"+this.Options.Id,this.Options.InvalidMessage);


    }

    ExecuteTruAction(immediate:boolean) {
        if(this.Options.IsInvalidWhenTrue)
            this.Field.AddError( "Validation_"+this.Options.Id,this.Options.InvalidMessage);
        else
            this.Field.RemoveError("Validation_"+this.Options.Id);
    }




}